const auxDiv = (props) => props.children

export default auxDiv;